

























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Event, Ticket } from '@openticket/lib-shop';
import { getSelectorClass } from '@/utils';
import EventSummaryHeader from '@/pages/shop/components/EventSummaryHeader.vue';

@Component({
    components: {
        EventSummaryHeader,
    },
})
export default class EventCard extends Vue {
    @Prop() event!: Event;

    private get eventSelectorClass(): string {
        return getSelectorClass('event', this.event.guid);
    }

    get ticketsAvailableCount(): number {
        if (this.event.hidden) {
            return 0;
        }

        return this.event.tickets.reduce(
            (carry: number, ticket: Ticket) =>
                ticket.status !== 'available' || ticket.hidden
                    ? carry
                    : carry + 1,
            0
        );
    }
}
